
import { getInfo,userSign,anonymousLogin } from '@/request/business';
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    user:null,
    permissions: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER: (state, user) => {
      state.user = user
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        userInfo["platform"] = "private_frontend_simplify"
        userSign(userInfo)
          .then(res => {
            if (res.success === true) {
              setToken(res.token)
              commit('SET_TOKEN', res.token)
            }
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    anonymousLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        userInfo["platform"] = "private_frontend_simplify"
        anonymousLogin(userInfo)
            .then(res => {
              if (res.success === true) {
                setToken(res.token)
                commit('SET_TOKEN', res.token)
              }
              resolve(res)
            })
            .catch(error => {
              reject(error)
            })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo()
          .then(res => {

            commit('SET_USER', res.user);
            // commit('SET_AVATAR', avatar)
            commit('SET_PERMISSIONS', res.permissions)
            resolve(res)
          })
          .catch(error => {

            reject(error)
          })
      })
    },

    // // 退出系统
    // LogOut({ commit, state }) {
    //   return new Promise((resolve, reject) => {
    //     logout(state.token)
    //       .then(() => {
    //         commit('SET_TOKEN', '')
    //         commit('SET_NAME', '')
    //         commit('SET_AVATAR', '')
    //         commit('SET_ROLES', [])
    //         commit('SET_PERMISSIONS', [])
    //         removeToken()
    //         resolve()
    //       })
    //       .catch(error => {
    //         reject(error)
    //       })
    //   })
    // },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '')
        commit('SET_USER', '')
        commit('SET_PERMISSIONS', [])
        removeToken()
        resolve()
      })
    }
  }
}

export default user
